import Api from './Api.js'

export default {
    fetchPosts() {
        return Api().get()
    },
    getPost(id) {
        return Api().get(`/${id}`)
    }
}